




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class indexPop extends Vue {
  $router:any;
  mounted() {}
  handleClick() {
    this.$emit("changIndexPopTF", false);
  }
  goSearchPage(){
    window.location.href='http://m.chexun.com/search/sindex.aspx'
  }
  goUrl(index: any) {
    switch (index) {
      case 0:
        window.location.reload();
        break;
      case 1:
        this.$router.push({
          path: "/cjCarType",
        });
        break;
      case 2:
        window.location.href = "http://m.chexun.com/";
        break;
    }
  }
}
